// extracted by mini-css-extract-plugin
export var borderRadius = "_9q-4";
export var large = "_9q-3";
export var logoContainer = "_9q-0";
export var nameLogo = "_9q-2";
export var small = "_9q-1";